export const useAndroidHardwareBackPressHandler = () => {};
